function myFunction()
{var e=document.getElementById("dots");
 var n=document.getElementById("more");
 var t=document.getElementById("myBtn");
 

 if (e.style.display === "none") {
   e.style.display = "inline";
   t.innerHTML = "Read More";
   n.style.display = "none";
 } else {
   e.style.display = "none";
   t.innerHTML = "Read Less...";
   n.style.display = "inline";
 }

}
//# sourceMappingURL=/s/files/1/1689/3145/t/36/assets/read_more.js.map?v=1640150302
